export default "__VITE_ASSET__CGzg0O$o__"